/**
 * @flow
 * @relayHash 42ebb44aecb53f5ece7e7dcc288eb5f6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailReturnOrderInput = {|
  returnOrderId: string
|};
export type EmailReturnOrderMutationVariables = {|
  input: EmailReturnOrderInput
|};
export type EmailReturnOrderMutationResponse = {|
  +emailReturnOrder: {|
    +success: boolean
  |}
|};
export type EmailReturnOrderMutation = {|
  variables: EmailReturnOrderMutationVariables,
  response: EmailReturnOrderMutationResponse,
|};
*/


/*
mutation EmailReturnOrderMutation(
  $input: EmailReturnOrderInput!
) {
  emailReturnOrder(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailReturnOrderInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "emailReturnOrder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailReturnOrderPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EmailReturnOrderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "EmailReturnOrderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "EmailReturnOrderMutation",
    "id": null,
    "text": "mutation EmailReturnOrderMutation(\n  $input: EmailReturnOrderInput!\n) {\n  emailReturnOrder(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4adeca778e822e8d2f33aadcb494803b';
module.exports = node;
